import * as React from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'umi';
import isEmpty from 'lodash/isEmpty';

import { INTL_ENTITY } from '@/utils/intl';
import LeadDropdownFilter from '@/components/Filters/LeadDropdownFilter';
import * as ProductGroupSelectors from '@/selectors/productGroupSelectors';
import { ProductGroupModel } from '@/typings/models/ProductGroup';
import styles from '@/components/Filters/index.less';
import PERMISSIONS from '@/constants/permissions';
import { createProductGroupRequest } from '@/services/api/productGroup';

export const ProductGroupRender = ({ productGroup }: { productGroup: ProductGroupModel }) => {
  return <span>{productGroup?.label}</span>;
};

const ProductGroupSelect = (props: any) => {
  const productGroupList: ProductGroupModel[] = useSelector(
    ProductGroupSelectors.selectProductGroupList,
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (isEmpty(productGroupList)) {
      dispatch({
        type: 'productGroups/fetchProductGroups',
      });
    }
  }, []);

  const handleSelectionChange = (productGroupId, option) => {
    props.onChange && props.onChange(productGroupId, option);
  };

  const handleCreateProductGroup = async (searchValue) => {
    try {
      const Response = await createProductGroupRequest({
        data: {
          label: searchValue,
        },
      });
      dispatch({
        type: 'productGroups/fetchProductGroups',
      });
      props.onChange(Response?.data?.data?.uuid, Response?.data?.data);
    } catch (error) {
      console.error('Failed to create product group:', error);
    }
  };

  return (
    <LeadDropdownFilter
      treeData={productGroupList?.map((productGroup) => ({
        title: productGroup.label,
        value: productGroup.uuid,
        key: productGroup.uuid,
        ...productGroup,
      }))}
      className={styles.multipleBranchesFilterDropdown}
      optionLabelKey={'label'}
      optionValueKey={'uuid'}
      filterKey={props.filterKey || 'product_group'}
      options={productGroupList}
      {...props}
      value={props.value === -1 ? undefined : props.value}
      onChange={handleSelectionChange}
      onCreate={props.hasCreate ? handleCreateProductGroup : undefined}
      createEntity={INTL_ENTITY.PRODUCT_GROUP}
      createPermission={[
        PERMISSIONS.PRODUCT_GROUPS.CREATE,
        PERMISSIONS.BUSINESS_PARTNER,
      ]}
      selectProps={{
        ...props.selectProps,
        variant: props.selectProps?.variant || 'underlined',
      }}
    />
  );
};

export default ProductGroupSelect;
